import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { apiList } from '../api/callAPI';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import Topbar from '../components/topbar/Topbar';
import Copyright from '../components/copyright/Copyright';

import useUser from '../hook/useUser';
import * as basicConstants from '../constants/basic';
import * as alertConstants from '../constants/alertMsg';
import { CustomBox } from '../components/CustomComp';
import theme from '../theme';

import Toolbar from '@mui/material/Toolbar';

const MainLayout = (props) => {
  const { userData, alertMsg  } = useUser();

  return (
    <>
      <Box        
        sx={{
          position: 'relative',
          left:{
            xl: '180px',
            lg: '200px',
            md: 0
          },
          width: {
            xl: '90%',
            lg: '85%',
            md: '100%'
          },
          minHeight: '100vh',
          paddingBottom: '40px',
        }}
      >
        {
          userData.role &&
            <>
              <Topbar userData={userData} /> 
              <CustomBox component="main">
                <Container maxWidth="false">
                  <main>
                    { React.cloneElement(props.children, { userData: userData }) }
                  </main>
                </Container>
              </CustomBox>
            </>
        }  

        <Copyright style={{ textAlign: 'right', color: theme.palette.grey.main }} />
        
      </Box>
    </>
  );
}

export default MainLayout;